<template>
  <qc-container class="flex">
        <div class="tree-box">
          <el-button type="primary"  size="mini" class="btn" @click="append()">添加主菜单</el-button>
          <div class="mt20">
            <el-input class="w300" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          </div>
          <div class="tree">
            <el-tree
              :data="tableData"
              node-key="id"
              :filter-node-method="filterNode"
              ref="tree"
              accordion
              :default-expanded-keys="[id]"
              :expand-on-click-node="false">

              <template #default="{ node, data }">
              <span class="custom-tree-node">
<!--                <span><i v-show="data.icon" :class="data.icon"></i>{{ data.name }}<span v-if="data.type===2" class="ml20 red f12">(功能)</span></span>-->
                <span><i v-show="data.icon" :class="data.icon"></i>{{ data.name }}<span v-if="data.type===2" class="ml20 red f12">(功能)</span></span>
              <span  class="ml20 el-ic" >
                <i v-if="data.type===1" class="el-icon-plus" title="添加菜单/功能" @click="() => append(data)"></i>
                <i class="el-icon-setting" title="编辑" @click="() => update(data)"></i>
                <i v-if="!(data.children&&data.children.length>0)" class="el-icon-delete" title="删除" @click="() => remove(node, data)"></i>
              </span>
              </span>
              </template>

              <!--            <div class="custom-tree-node" slot-scope="{ node, data }">-->
              <!--              <span><i v-show="data.icon" :class="data.icon"></i>{{ data.name }}<span v-if="data.type===2" class="ml20 red f12">(功能)</span></span>-->
              <!--              <span  class="ml20 el-ic" >-->
              <!--                <i v-if="data.type===1" class="el-icon-plus" title="添加菜单/功能" @click="() => append(data)"></i>-->
              <!--                <i class="el-icon-setting" title="编辑" @click="() => update(data)"></i>-->
              <!--                <i v-if="!(data.children&&data.children.length>0)" class="el-icon-delete" title="删除" @click="() => remove(node, data)"></i>-->
              <!--              </span>-->
              <!--            </div>-->
            </el-tree>
          </div>
        </div>
        <div v-if="addRow" class="add-edit-box" style="margin-left: 20px">
          <div v-if="!addRow.type" >
            <h3>您是要在<span class="red">{{addRow.fName}}</span>下添加什么？</h3>
            <div>
              <el-button @click="addRow.type=1" size="mini">菜单</el-button>
              <el-button @click="addRow.type=2" size="mini">功能</el-button>
            </div>
          </div>
          <div v-else="">
            <h3  class="mt0 ml5">{{addRow.id?"编辑":"添加"}}{{addRow.type===1?"菜单":"功能"}}</h3>
            <el-form   ref="ruleForm" :model="addRow" :rules="rules"  label-width="150px">
              <el-form-item v-if="addRow.fName" class="row" label="上级菜单" >
                <el-input class="w300" disabled="disabled" readonly="readonly" v-model="addRow.fName" placeholder="请输入名称"></el-input>
              </el-form-item>
              <el-form-item class="row" label="名称" prop="name">
                <el-input class="w300" v-model="addRow.name" placeholder="请输入名称"></el-input>
              </el-form-item>
              <el-form-item v-if="addRow.type===1"  class="row" label="请求地址" prop="url">
                <el-input class="w300" v-model="addRow.url" placeholder="请输入请求地址"></el-input>
              </el-form-item>
              <el-form-item class="row" label="栏目代码" prop="code">
                <el-input class="w300" v-model="addRow.code" placeholder="请输入栏目代码"></el-input>
              </el-form-item>
              <el-form-item v-if="addRow.type===1" class="row" label="图标" prop="icon">
                <icon-box v-model="addRow.icon"></icon-box>
              </el-form-item>
              <el-form-item>
                <el-button  @click="save()" size="mini" type="primary" >保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
  </qc-container>

</template>
<script>
  import IconBox from '../../../components/base/icon-box'
  import QcContainer from "../../../components/el/layout/qc-container";
  export default {
    name: 'sys-menu-list',
    components: {QcContainer, IconBox},
    data () {
      return {
        tableData:[],
        filterText:"",
        addRow:null,
        rules:{
          name: [
            {required: true, message: '请输入名称', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入栏目代码', trigger: 'blur'}
          ],
        },
        id:""
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    mixins: [tableBase],
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      loadData(type){
        this.addRow = null;
        let data = this.$refs['tree'].getCurrentNode	();
        if(data){
          this.id = type?data.fid:data.id;
        }
        this.simplePost("/api/mgr/auth/" +"list",null,result=>{
          this.tableData = result.data;
        })
      },
      append(data){
        if(data){
          this.addShow(data);
        }else{
          this.addShow(data,1);
        }
      },
      addShow(data,type){
        if(data){
          this.addRow = {id:"",name:"",url:"",fId:data.id,fName:data.name,icon:"",sort:"",level:data.level+1,code:"",type:type,source:0};
        }else{
          this.addRow = {id:"",name:"",url:"",fId:"",icon:"",sort:"",level:1,code:"",type:type,source:0};
        }
      },
      remove(node,data){
        this.msgConfirm(Api.menu+"delete",{id:data.id},()=>{
          this.loadData(1);
        });
      },
      update(data){
        this.addRow = {id:data.id,name:data.name,url:data.url,fId:data.fId,icon:data.icon,sort:data.sort,level:data.level,code:data.code,type:data.type,source:0};;
      },
      save(){
        this.simplePost(Api.menu+"addOrUpdate",this.addRow,()=>{
          this.loadData();
        })
      }
    },
    mounted () {
      this.loadData();
    }
  }
</script>

<style lang="less" scoped>
  .tree-box{
    width: 400px;
    .tree{
      margin-top: 30px;
    }
    .btn{
      margin: 20px 0;
    }
  }
  .el-tree-node__content {
    &:hover {
      background: #89c2f7;
    }
  }
  .el-tree-node:focus>.el-tree-node__content{
    background-color: #5daaf0;
  }
  .custom-tree-node{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    color: #4386c6;
  }
  .el-ic {
    display: none;
    i, span {
      padding: 0 14px;
      font-size: 18px;
      font-weight: 600;
    }
    .svg-icon {
      color: #4386c6;
    }
  }

  .el-tree-node__content {
    height: 38px;
  }

  .el-tree-node__expand-icon {
    color: #428bca;
    /*padding: 10px 10px 0px 10px !important;*/
  }

  .el-tree-node__content:hover .el-ic {
    color: #428bca !important;
    display: inline-block;

  }

  .el-tree-node__content:hover {
    font-weight: bold;
  }

  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content :hover {
    .el-tree-node__expand-icon.is-leaf {
      color: transparent;
      cursor: default;
    }
    /*background-color: #3998d9;*/
    .custom-tree-node {
      font-weight: bold;
    }
    .el-tree-node__expand-icon {
      font-weight: bold;
    }

  }

  .el-dialog__body {
    .upload-container .image-preview .image-preview-wrapper img {
      height: 100px;
    }
    .el-dialog .el-collapse-item__wrap {
      padding-top: 0px;

    }
    .spatial_img {
      .el-collapse-item__wrap {
        margin-bottom: 0;
        padding-top: 0px;
      }
    }

    .upload-container .image-preview .image-preview-wrapper {
      width: 120px;
    }

    .upload-container .image-preview .image-preview-action {
      line-height: 100px;
      height: 100px;
    }
  }

  .menu-box{
    display: flex;
    .add-edit-box{
      flex: 1;
      margin-left: 20px;
    }
  }

</style>
